/** @jsxImportSource @emotion/react */
import React from 'react';
import {
  FullPageWidthWrapper,
  HEADER_ID,
} from '../../../component_library/components/Grid';
import useHeaderWithLogoOnly from './hooks/use-header-with-logo-only';
import { TOP_OF_PAGE_MARGIN_PIXELS } from '../../../pages/enrollment-abc/constants';
import { useHeaderNavigationHeights } from './header-navigation-context-provider';
import { LogoLink } from './LogoLink';

interface IProps {
  isLogoInCenter?: boolean;
}

const HeaderWithLogoOnly: React.FC<IProps> = ({ isLogoInCenter = false }) => {
  const { companyLogo, homepagePath, isDesktop } = useHeaderWithLogoOnly();

  const { headerRef } = useHeaderNavigationHeights();

  return (
    <FullPageWidthWrapper
      id={HEADER_ID}
      ref={headerRef}
      sx={{
        display: 'flex',
        justifyContent: isDesktop && !isLogoInCenter ? 'flex-start' : 'center',
      }}
    >
      {!!companyLogo && (
        <LogoLink homepagePath={homepagePath}>
          <img
            style={{
              marginTop: `${TOP_OF_PAGE_MARGIN_PIXELS}px`,
              marginBottom: '64px',
              maxHeight: '60px',
              maxWidth: '160px',
            }}
            src={companyLogo}
            alt=""
          />
        </LogoLink>
      )}
    </FullPageWidthWrapper>
  );
};

export default HeaderWithLogoOnly;
